import { render, staticRenderFns } from "./WebpackDashboard.vue?vue&type=template&id=bf65a62e"
import script from "./WebpackDashboard.vue?vue&type=script&lang=js"
export * from "./WebpackDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports